module.exports = __webpack_public_path__ + "static/media/Nguyen_Thanh_Hung.fddd2d22.png";